const infractionStatus = {
  CREATED: 'CREATED',
  ANALYSIS: 'ANALYSIS',
  OPEN: 'OPEN',
  ACKNOWLEDGED: 'ACKNOWLEDGED',
  CONTESTATION_RECEIVED: 'CONTESTATION_RECEIVED',
  AGREED: 'AGREED',
  DISAGREED: 'DISAGREED',
  CANCELLED: 'CANCELLED',
  PROCESSING: 'PROCESSING'
};

module.exports = infractionStatus;
